import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatchPropertyPipe } from './match-property.pipe';
import { UTCOffsetPipe } from './utc-offset.pipe';
import { MonthPipe } from './month.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { CondenseAddressPipe } from './condense-address.pipe';
import { EnableActionItemFilterPipe } from './enable-action-item-filter.pipe';
import { RemoveSpecialCharactersPipe } from './remove-special-characters.pipe';


@NgModule({
	declarations: [
		MatchPropertyPipe,
		UTCOffsetPipe,
		MonthPipe,
		SafeHtmlPipe,
		CondenseAddressPipe,
    EnableActionItemFilterPipe,
    RemoveSpecialCharactersPipe
	],
	imports: [
		CommonModule
	],
	exports: [
		MatchPropertyPipe,
		UTCOffsetPipe,
		MonthPipe,
		SafeHtmlPipe,
		CondenseAddressPipe,
    EnableActionItemFilterPipe,
    RemoveSpecialCharactersPipe
	]
})
export class PipesModule {
}
